<div class="customers-content-area" *ngIf="curve">
  <form clrForm  autocomplete="off">
    <clr-input-container>
      <label class="clr-col-1">Name:</label>
      <input clrInput class="clr-col-11" type="text" size="40" [(ngModel)]="curve.name" (ngModelChange)="curveEdit=true" name="curvename" />
    </clr-input-container>
    <clr-input-container>
      <label class="clr-col-1">Key:</label>
      <input clrInput class="clr-col-11" type="text" size="40" [(ngModel)]="curve.key" (ngModelChange)="curveEdit=true" name="curvekey" />
    </clr-input-container>
    <clr-input-container>
      <label class="clr-col-1">Points:</label>
      <input clrInput class="clr-col-11" type="number" min="2" max="10" [(ngModel)]="curve.points" (change)="updateCurveGraph()" name="curvepoints" />
    </clr-input-container>
  </form>
  <div class="clr-row">
    <div class="clr-col-3">
      <form clrForm>
        <clr-input-container>
          <label>In1:</label>
          <input clrInput class="curve-input" type="number" min="-99999" max="99999" step="1" [(ngModel)]="curve.in1" (change)="updateCurveGraph()" name="curvein1" />
        </clr-input-container>
        <clr-input-container>
          <label>In2:</label>
          <input clrInput class="curve-input" type="number" min="-99999" max="99999" step="1" [(ngModel)]="curve.in2" (change)="updateCurveGraph()" name="curvein2" />
        </clr-input-container>
        <clr-input-container *ngIf="curve.points >= 3">
          <label>In3:</label>
          <input clrInput class="curve-input" type="number" min="-99999" max="99999" step="1" [(ngModel)]="curve.in3" (change)="updateCurveGraph()" name="curvein3" />
        </clr-input-container>
        <clr-input-container *ngIf="curve.points >= 4">
          <label>In4:</label>
          <input clrInput class="curve-input" type="number" min="-99999" max="99999" step="1" [(ngModel)]="curve.in4" (change)="updateCurveGraph()" name="curvein4" />
        </clr-input-container>
        <clr-input-container *ngIf="curve.points >= 5">
          <label>In5:</label>
          <input clrInput class="curve-input" type="number" min="-99999" max="99999" step="1" [(ngModel)]="curve.in5" (change)="updateCurveGraph()" name="curvein5" />
        </clr-input-container>
        <clr-input-container *ngIf="curve.points >= 6">
          <label>In6:</label>
          <input clrInput class="curve-input" type="number" min="-99999" max="99999" step="1" [(ngModel)]="curve.in6" (change)="updateCurveGraph()" name="curvein6" />
        </clr-input-container>
        <clr-input-container *ngIf="curve.points >= 7">
          <label>In7:</label>
          <input clrInput class="curve-input" type="number" min="-99999" max="99999" step="1" [(ngModel)]="curve.in7" (change)="updateCurveGraph()" name="curvein7" />
        </clr-input-container>
        <clr-input-container *ngIf="curve.points >= 8">
          <label>In8:</label>
          <input clrInput class="curve-input" type="number" min="-99999" max="99999" step="1" [(ngModel)]="curve.in8" (change)="updateCurveGraph()" name="curvein8" />
        </clr-input-container>
        <clr-input-container *ngIf="curve.points >= 9">
          <label>In9:</label>
          <input clrInput class="curve-input" type="number" min="-99999" max="99999" step="1" [(ngModel)]="curve.in9" (change)="updateCurveGraph()" name="curvein9" />
        </clr-input-container>
        <clr-input-container *ngIf="curve.points >= 10">
          <label>In10:</label>
          <input clrInput class="curve-input" type="number" min="-99999" max="99999" step="1" [(ngModel)]="curve.in10" (change)="updateCurveGraph()" name="curvein10" />
        </clr-input-container>

      </form>
    </div>
    <div class="clr-col-3">
      <form clrForm clrLayout="horizontal" autocomplete="off">
        <clr-input-container>
          <label>Out1:</label>
          <input clrInput class="curve-input" type="number" min="-99999" max="99999" step="1" [(ngModel)]="curve.out1" (change)="updateCurveGraph()" name="curveout1" />
        </clr-input-container>
        <clr-input-container>
          <label>Out2:</label>
          <input clrInput class="curve-input" type="number" min="-99999" max="99999" step="1" [(ngModel)]="curve.out2" (change)="updateCurveGraph()" name="curveout2" />
        </clr-input-container>
        <clr-input-container *ngIf="curve.points >= 3">
          <label>Out3:</label>
          <input clrInput class="curve-input" type="number" min="-99999" max="99999" step="1" [(ngModel)]="curve.out3" (change)="updateCurveGraph()" name="curveout3" />
        </clr-input-container>
        <clr-input-container *ngIf="curve.points >= 4">
          <label>Out4:</label>
          <input clrInput class="curve-input" type="number" min="-99999" max="99999" step="1" [(ngModel)]="curve.out4" (change)="updateCurveGraph()" name="curveout4" />
        </clr-input-container>
        <clr-input-container *ngIf="curve.points >= 5">
          <label>Out5:</label>
          <input clrInput class="curve-input" type="number" min="-99999" max="99999" step="1" [(ngModel)]="curve.out5" (change)="updateCurveGraph()" name="curveout5" />
        </clr-input-container>
        <clr-input-container *ngIf="curve.points >= 6">
          <label>Out6:</label>
          <input clrInput class="curve-input" type="number" min="-99999" max="99999" step="1" [(ngModel)]="curve.out6" (change)="updateCurveGraph()" name="curveout6" />
        </clr-input-container>
        <clr-input-container *ngIf="curve.points >= 7">
          <label>Out7:</label>
          <input clrInput class="curve-input" type="number" min="-99999" max="99999" step="1" [(ngModel)]="curve.out7" (change)="updateCurveGraph()" name="curveout7" />
        </clr-input-container>
        <clr-input-container *ngIf="curve.points >= 8">
          <label>Out8:</label>
          <input clrInput class="curve-input" type="number" min="-99999" max="99999" step="1" [(ngModel)]="curve.out8" (change)="updateCurveGraph()" name="curveout8" />
        </clr-input-container>
        <clr-input-container *ngIf="curve.points >= 9">
          <label>Out9:</label>
          <input clrInput class="curve-input" type="number" min="-99999" max="99999" step="1" [(ngModel)]="curve.out9" (change)="updateCurveGraph()" name="curveout9" />
        </clr-input-container>
        <clr-input-container *ngIf="curve.points >= 10">
          <label>Out10:</label>
          <input clrInput class="curve-input" type="number" min="-99999" max="99999" step="1" [(ngModel)]="curve.out10" (change)="updateCurveGraph()" name="curveout10" />
        </clr-input-container>

      </form>
    </div>
    <div class="clr-col-6">
      <canvas #curveGraphCanvas id="curveGraphCanvas">{{curveGraphCanvas}}</canvas>
    </div>
  </div>
  <!-- <clr-input-container>
    <label class="clr-col-12">Name:</label>
    <input clrInput class="clr-col-12" type="text" size="40" [(ngModel)]="curve.name" name="curvename" />
  </clr-input-container> -->

  <button type="button" class="btn btn-primary save-button" [disabled]="!curve || !curveEdit" [clrLoading]="loading" (click)="save()">
    <clr-icon shape="floppy"></clr-icon>
    Save
  </button>

  <!-- <div>
    <canvas #curveGraphCanvas id="curveGraphCanvas">{{curveGraphCanvas}}</canvas>
  </div> -->
</div>
